module.exports = __webpack_public_path__ + "img/coupons.83210b9d.png";